import Icon from '@ant-design/icons';
import type { InputProps } from 'antd';
import { Input } from 'antd';
import type {
  ChangeEventHandler,
  NamedExoticComponent,
  RefObject,
} from 'react';
import { memo, useCallback } from 'react';
import { StyledInput } from './style';

interface SearchInputProps extends Omit<InputProps, 'onChange'> {
  searchInputRef?: RefObject<Input>;
  onChange?: (value: string) => void;
  prefix?: boolean;
  hideClearAll?: boolean;
  testId?: string;
}
const SearchInput: NamedExoticComponent<SearchInputProps> = memo(
  ({
    suffix,
    onChange,
    value,
    placeholder,
    searchInputRef,
    hideClearAll,
    prefix,
    testId,
    ...rest
  }) => {
    const onClear = useCallback(() => {
      if (onChange) {
        onChange('');
      }

      if (searchInputRef && searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, [onChange, searchInputRef]);

    const onInputChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
      e => {
        if (onChange) {
          onChange(e.target.value);
        }
      },
      [onChange],
    );

    const suffixRender = () => {
      if (suffix && !hideClearAll) {
        return (
          <Icon
            className="close-circle"
            type="close-circle"
            onClick={onClear}
            data-testid="clear-search"
          />
        );
      }
      if (!prefix) {
        return <Icon type="search" />;
      }
      return <></>;
    };

    return (
      <StyledInput
        size="middle"
        {...rest}
        ref={searchInputRef}
        placeholder={placeholder}
        onChange={onInputChange}
        value={value}
        data-testid={testId}
        allowClear={false}
        prefix={prefix}
        suffix={suffixRender()}
      />
    );
  },
);
export { SearchInput };
